<script lang="ts" setup>
import { ref } from 'vue'

import { Button, useConfirmModal } from '@collector/shared-ui'
import { useEventState } from '@desktop/views/Relation/composables'

import ResetEventConfirmModal from './ResetEventConfirmModal.vue'

// composables
const { openModalCancelConfirm } = useConfirmModal()
const { resetEvent: _resetEvent } = useEventState()

// state
const processing = ref(false)

// methods
async function promptForReset(): Promise<void> {
  const result = await openModalCancelConfirm(ResetEventConfirmModal)

  if (result) {
    resetEvent()
  }
}

async function resetEvent(): Promise<void> {
  try {
    processing.value = true

    await _resetEvent()

    window.location.reload()
  } finally {
    processing.value = false
  }
}
</script>

<template>
  <Button
    class="border-neutral-light-7 bg-neutral-light-7 hover:bg-neutral-light-3 hover:border-neutral-light-3"
    icon="repeat"
    size="sm"
    square
    :disabled="processing"
    @click="promptForReset()"
  />
</template>
